import { render, staticRenderFns } from "./SourceFiles.vue?vue&type=template&id=4c01b97e"
import script from "./SourceFiles.vue?vue&type=script&lang=ts"
export * from "./SourceFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports